const riot = require('riot');

riot.tag2('atom-tabs', '<div class="relative f overflow-scroll scrollbar-none"> <div class="border-bottom bw3 cursor-pointer z1 {tab.id === current ? &quot;border-navy&quot; : &quot;border-transparent&quot;}" each="{tab in opts.items}" onclick="{onChangeTab}" data-current="{tab.id === current ? &quot;1&quot; : null}"> <div class="px12 py15 ts-hxs word-break-keep {tab.id === current ? &quot;text-gray_80&quot; : &quot;text-gray_60&quot;}">{tab.label}</div> </div> <div class="absolute b0 r0 l0 h1 bg-gray_10 z0"></div> </div>', '', '', function(opts) {
    this.on('mount', () => {
      if (this.opts.current) {
        this.current = this.opts.current;
      }
    });

    this.setCurrent = (id) => {
      this.current = id;
      this.update();
    };

    this.onChangeTab = (e) => {

      if (e.item.tab.id === this.current) return ;
      this.setCurrent(e.item.tab.id);

      this.trigger('change', {
        current: this.current,
      });
      this.bubbleTrigger('tabChange', {
        current: this.current,
      });
    };
});